import { atom } from 'recoil';

export const OpeningDialogIdStates = atom({
    key: 'OpeningDialogIdStates', 
    default: [], 
});